import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation} from '@angular/core';
import {DashboardService} from '../../../../../services/dashboard.service';

@Component({
	selector: 'app-amelioration-point-widget',
	templateUrl: './amelioration-point-widget.component.html',
	styleUrls: ['./amelioration-point-widget.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AmeliorationPointWidgetComponent implements OnInit, OnChanges {
	@ViewChild('donutAmelioraionRef') donutAmeliorationRef: any;

	public isLoading = true;
	public data: any;
	public options: any;
	@Input() referencial: any;

	constructor(private _dashboard: DashboardService) {
	}

	private getData(): void {
		this._dashboard.postActionType(this.referencial).subscribe(
			(res: any) => {
				this.data = res.data;
				this.options = res.data;
				this.isLoading = false;
			},
			(err: any) => {
				console.error(err);
				this.isLoading = false;
			},
		);
	}

	ngOnInit(): void {
		this.getData();
	}

	ngOnChanges(changes: SimpleChanges): void {
		console.log(changes);
		this.getData();
	}
}
